export const INPUT_TYPE = {
    text: 'text',
    password: 'password',
    number: 'number',
    email: 'email',
    tel: 'tel',
} as const

export const INPUT_THEME = {
    primary: 'primary',
    secondary: 'secondary',
    clear: 'clear',
    error: 'error',
} as const

export const INPUT_AUTOCOMPLETE = {
    on: 'on',
    off: 'off',
    email: 'email',
    firstname: 'firstname',
    lastname: 'lastname',
    'current-password': 'current-password',
    'given-name': 'given-name',
    'family-name': 'family-name',
    'street-address': 'street-address',
    'address-level1': 'address-level1',
    'address-level2': 'address-level2',
    'country-name': 'country-name',
    'postal-code': 'postal-code',
    tel: 'tel',
    'cc-number': 'cc-number',
    'cc-name': 'cc-name',
    'cc-exp': 'cc-exp',
    cvc: 'cvc',
} as const

export const INPUT_EVENT = {
    update: 'update:modelValue',
} as const
